import { render, staticRenderFns } from "./CustomSearchBox.vue?vue&type=template&id=1d080840&lang=pug&"
import script from "./CustomSearchBox.vue?vue&type=script&lang=js&"
export * from "./CustomSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomSearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports